
























import { Component, Vue, Prop } from "vue-property-decorator";
// import Avatar from "@/components/Avatar.vue";
import { formatUpyunUrl } from "@/utils";
import { setCount } from "@/apis/home";
import md5 from "blueimp-md5";
@Component({
  components: {}
})
export default class ProjectsItem extends Vue {
  @Prop({ required: true }) private item!: any;
  formatUpyunUrl = formatUpyunUrl;

  handleDetail() {
    this.$router.push(`/project?ukey=${this.item.ukey}`);
  }
  async handleConsult() {
    let params = {
      type: 1,
      type_id: this.item.project_id,
      md5: md5(1 + "&" + this.item.project_id + "&Z6pdIPQ4aFDwgxOZ")
    };
    await setCount(params);
    openJesongChat("32182", "102497");
  }
  handleCourse() {
    let index = 2;
    if (this.item.ukey == "emba") {
      index = 2;
    } else if (this.item.ukey == "emba") {
      index = 1;
    } else {
      index = 3;
    }
    this.$router.push(`/course?type=${index}`);
  }
}
